export type TransportPhase = 'ack' | 'result'

export class TransportTimeoutException extends Error {
  readonly phase: TransportPhase

  constructor(phase: TransportPhase, message?: string) {
    super(message ?? `transport timeout at ${phase}`)
    this.name = 'TransportTimeoutException'
    this.phase = phase
    // es5 ターゲットで instanceof を機能させる
    Object.setPrototypeOf(this, TransportTimeoutException.prototype)
  }
}
